import { render } from "./ButtonField.vue?vue&type=template&id=b492349e"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ButtonField.vue"]])

export default __exports__